import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Ex = makeShortcode("Ex");
const Translation = makeShortcode("Translation");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`行進曲と合唱 （カルメン）`}</h1>
    <h4>{`Les voici ! Voici la quadrille !`}</h4>
    <p>{`このオペラの中でも一番盛り上がる場面です。前奏曲にも現れる最も有名なメロディが出てきます。子どもたち、ソプラノ、テノール、バスによる合唱。`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Carmen - Les voici! Voici la quadrille! - Arena di Verona 2016`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/oyNUi7OFVfM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`CARMEN VOICI LA QUADRILLE`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/retxXisWfn4" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <p>
  <Ex m="彼ら、それら" mdxType="Ex">Les</Ex>{" "}
  <Ex m="ここに〜がある（例えば Me voici. なら「私はここにいます」の意味）" mdxType="Ex">
    voici
  </Ex>{" "}
  ! Les voici ! Voici{" "}
  <Ex m="クアドリリャ（= cuadrilla スペイン語）闘牛でチームを組む小グループのこと。この意味では女性名詞" mdxType="Ex">
    la quadrille
  </Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <p>Les voici! Les voici ! Les voici ! oui, les voici ! Voici la quadrille !</p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>Les voici ! voici la quadrille</p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <p>
  La quadrille <Ex m="de + les" mdxType="Ex">des</Ex>{" "}
  <Ex m="闘牛士（複数）（スペイン語）" mdxType="Ex">Toreros</Ex> !
    </p>
    <Translation mdxType="Translation">闘牛士のクアドリリャだ！</Translation>
    <p>
  <Ex m="〜の上に" mdxType="Ex">Sur</Ex> <Ex m="槍（複数）" mdxType="Ex">les lances</Ex>,{" "}
  <Ex m="太陽" mdxType="Ex">le soleil</Ex>{" "}
  <Ex m="輝く" o="briller" mdxType="Ex">
    brille
  </Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">槍の上に、太陽が輝く！</Translation>
    <p>
  <Ex m="〜に（場所を表す前置詞）" mdxType="Ex">En</Ex> <Ex m="空気、空" mdxType="Ex">l'air</Ex>, en
  l'air, en l'air, en l'air,{" "}
  <Ex m="トック（裁判官などがかぶる縁無しの帽子）" mdxType="Ex">toques</Ex> et{" "}
  <Ex m="ソンブレロ（スペイン、ラテンアメリカで見られるつばの広い帽子）" mdxType="Ex">
    sombreros
  </Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">宙に舞う、トック帽にソンブレロ！</Translation>
    <p>Les voici ! voici la quadrille</p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <p>La quadrille des Toreros !</p>
    <Translation mdxType="Translation">闘牛士のクアドリリャだ！</Translation>
    <p>Les voici ! Les voici ! Les voici !</p>
    <Translation mdxType="Translation">ほら、来たぞ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="ここに、ほら" mdxType="Ex">Voici</Ex>,{" "}
  <Ex m="広いところへ出る、跳び出す（現在分詞）" o="déboucher" mdxType="Ex">
    débouchant
  </Ex>{" "}
  <Ex m="〜の上に" mdxType="Ex">sur</Ex> <Ex m="広場" mdxType="Ex">la place</Ex>,
    </p>
    <Translation mdxType="Translation">ほら、広場に出てくる</Translation>
    <p>
  Voici <Ex m="最初に" mdxType="Ex">d'abord</Ex>,{" "}
  <Ex m="歩く" o="marcher" mdxType="Ex">
    marchant
  </Ex>{" "}
  <Ex m="marcher au pasで「並足で行進する」 pas = 歩み（英語のstep）" mdxType="Ex">
    au pas
  </Ex>
  , Voici d'abord marchant au pas,
    </p>
    <Translation mdxType="Translation">ほら、最初に行進してくるのは</Translation>
    <p>
  <Ex m="警官（スペイン語）" mdxType="Ex">L'alguazil</Ex> à{" "}
  <Ex m="見苦しい、不快な" mdxType="Ex">vilaine</Ex> <Ex m="顔" mdxType="Ex">face</Ex>
    </p>
    <Translation mdxType="Translation">いやな顔したおまわりだ</Translation>
    <p>
  <Ex m="直訳すると「下に」、抗議の叫び" mdxType="Ex">À bas</Ex> ! à bas ! à bas ! à bas !
    </p>
    <Translation mdxType="Translation">ひっこめ！ ひっこめ！</Translation>
    <p>À bas l'Alguazil ! à bas !</p>
    <Translation mdxType="Translation">ひっこめ！ おまわりめ！</Translation>
    <p>À bas ! à bas ! à bas ! à bas !</p>
    <Translation mdxType="Translation">ひっこめ！ ひっこめ！</Translation>
    <p>Oui ! à bas ! à bas ! à bas ! à bas !</p>
    <Translation mdxType="Translation">そうだ！ ひっこめ！ ひっこめ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  Et <Ex m="それから、次に" mdxType="Ex">puis</Ex>{" "}
  <Ex m="挨拶する、敬礼する" o="saluer" mdxType="Ex">
    saluons
  </Ex>{" "}
  <Ex m="à + le" mdxType="Ex">au</Ex> <Ex m="通過" mdxType="Ex">passage</Ex>,
    </p>
    <Translation mdxType="Translation">それから行進に敬礼しよう</Translation>
    <p>
  Saluons les <Ex m="大胆な" mdxType="Ex">hardis</Ex>{" "}
  <Ex m="（スペイン語）闘牛士の助手" mdxType="Ex">Chulos</Ex> !
    </p>
    <Translation mdxType="Translation">果敢なチューロたちに敬礼しよう！</Translation>
    <p>
  Bravo ! viva ! <Ex m="栄光" mdxType="Ex">gloire</Ex> au <Ex m="勇気" mdxType="Ex">courage</Ex>
    </p>
    <Translation mdxType="Translation">ブラボー！ ばんざい！ その勇気に栄光あれ</Translation>
    <p>Voici les hardis Chulos !</p>
    <Translation mdxType="Translation">ほら、果敢なチューロたちだ！</Translation>
    <p>
  <Ex m="見る（命令形）" o="voir" mdxType="Ex">
    Voyez
  </Ex>{" "}
  <Ex m="バンデリリェロ（バンデリリャ（槍）で牛を突く役）（スペイン語）" mdxType="Ex">
    les Banderilleros
  </Ex>
  ,
    </p>
    <Translation mdxType="Translation">見てごらん、バンデリリェロだ</Translation>
    <p>
  Voyez <Ex m="なんという（感嘆を表す、英語のwhat）" mdxType="Ex">quel</Ex>{" "}
  <Ex m="空気、雰囲気" mdxType="Ex">air</Ex> de <Ex m="勇ましさ" mdxType="Ex">crânerie</Ex> !
    </p>
    <Translation mdxType="Translation">見てごらん、なんという勇ましさ！</Translation>
    <p>Voyez ! Voyez ! Voyez ! Voyez !</p>
    <Translation mdxType="Translation">見てごらん！ 見てごらん！</Translation>
    <p>
  <Ex m="なんという（感嘆を表す、英語のwhat）" mdxType="Ex">quels</Ex>{" "}
  <Ex m="目つき" mdxType="Ex">regards</Ex>, et{" "}
  <Ex m="次のétincelerに係る副詞句を作る（なんという輝きで刺繍がきらめくことか！）" mdxType="Ex">
    de quel
  </Ex>{" "}
  <Ex m="輝き" mdxType="Ex">éclat</Ex>
    </p>
    <Translation mdxType="Translation">あの目つき、あの輝き</Translation>
    <p>
  <Ex m="輝く" o="étinceler" mdxType="Ex">
    Étincelle
  </Ex>{" "}
  <Ex m="刺繍" mdxType="Ex">la broderie</Ex>
    </p>
    <Translation mdxType="Translation">刺繍がきらめく</Translation>
    <p>
  <Ex m="前のla broderieに係る（衣装の刺繍）" mdxType="Ex">De</Ex> <Ex m="彼らの" mdxType="Ex">leur</Ex>{" "}
  <Ex m="衣装" mdxType="Ex">costume</Ex> de <Ex m="戦い" mdxType="Ex">combat</Ex> !
    </p>
    <Translation mdxType="Translation">戦いの衣装！</Translation>
    <p>Voici les Banderilleros !</p>
    <Translation mdxType="Translation">ほら、バンドリリェロだ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="また別の（英語のanother、une = ひとつの、 autre = ほかの）" mdxType="Ex">
    Une autre
  </Ex>{" "}
  quadrille{" "}
  <Ex m="前に進む" o="s'avancer" mdxType="Ex">
    s'avance
  </Ex>{" "}
  ! Une autre quadrille s'avance !
    </p>
    <Translation mdxType="Translation">また別のクアドリリャがやって来る！</Translation>
    <p>
  Voyez{" "}
  <Ex m="ピカドール、場上から槍で牛を突き、弱らせる役（スペイン語）" mdxType="Ex">
    les Picadors
  </Ex>{" "}
  ! Voyez les Picadors !
    </p>
    <Translation mdxType="Translation">ピカドールを見てごらん！</Translation>
    <p>
  <Ex m="なんと（感嘆を表す。英語のhow）" mdxType="Ex">Comme</Ex> <Ex m="彼らは" mdxType="Ex">ils</Ex>{" "}
  <Ex m="〜である（英語のbe動詞）" o="être" mdxType="Ex">
    sont
  </Ex>{" "}
  <Ex m="美しい" mdxType="Ex">beaux</Ex> !
    </p>
    <Translation mdxType="Translation">なんという美しさ！</Translation>
    <p>
  Comme ils{" "}
  <Ex m="〜するだろう（近接未来を表す。動詞は次の行のharceler）" o="aller" mdxType="Ex">
    vont
  </Ex>{" "}
  <Ex m="de + le ここでのdeは道具・手段を表す「〜で」" mdxType="Ex">du</Ex>{" "}
  <Ex m="（槍の）穂先" mdxType="Ex">fer</Ex> de <Ex m="彼らの" mdxType="Ex">leur</Ex>{" "}
  <Ex m="槍" mdxType="Ex">lance</Ex>,
    </p>
    <Translation mdxType="Translation">槍の穂先で</Translation>
    <p>
  <Ex m="繰り返し攻撃する" mdxType="Ex">Harceler</Ex> <Ex m="横腹" mdxType="Ex">le flanc</Ex>{" "}
  <Ex m="de + les" mdxType="Ex">des</Ex> <Ex m="雄牛" mdxType="Ex">taureaux</Ex> !
    </p>
    <Translation mdxType="Translation">牛の横腹を攻め立てる！</Translation>
    <p>
  <Ex m="エスパーダ、とどめを刺す闘牛士（スペイン語）" mdxType="Ex">L'Espada</Ex> ! L'Espada
  ! L'Espada ! L'Espada !
    </p>
    <Translation mdxType="Translation">エスパーダだ！</Translation>
    <p>Escamillo ! Escamillo ! Escamillo ! Escamillo !</p>
    <Translation mdxType="Translation">エスカミーリョだ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  C'est l'Espada, la <Ex m="細い" mdxType="Ex">fine</Ex> <Ex m="刀身" mdxType="Ex">lame</Ex>,
    </p>
    <Translation mdxType="Translation">これぞエスパーダ、細身のつるぎ</Translation>
    <p>
  <Ex m="= l'espada （指示代名詞）" mdxType="Ex">Celui</Ex>{" "}
  <Ex m="関係代名詞、英語のwho, that" mdxType="Ex">qui</Ex>{" "}
  <Ex m="来る" o="venir" mdxType="Ex">
    vient
  </Ex>{" "}
  <Ex m="終わらせる" mdxType="Ex">terminer</Ex> <Ex m="すべて" mdxType="Ex">tout</Ex>,
    </p>
    <Translation mdxType="Translation">すべてを終わらせるためにやってきた</Translation>
    <p>
  <Ex m="関係代名詞、英語のwho, that" mdxType="Ex">Qui</Ex>{" "}
  <Ex m="現れる" o="paraître" mdxType="Ex">
    paraît
  </Ex>{" "}
  <Ex m="〜の終わりに" mdxType="Ex">à la fin du</Ex> <Ex m="惨事、悲劇的事件" mdxType="Ex">drame</Ex>
    </p>
    <Translation mdxType="Translation">ドラマの最後に現れて</Translation>
    <p>
  Et qui <Ex m="叩く" mdxType="Ex">frappe</Ex> le <Ex m="最後の" mdxType="Ex">dernier</Ex>{" "}
  <Ex m="一撃" mdxType="Ex">coup</Ex> !
    </p>
    <Translation mdxType="Translation">とどめの一撃！</Translation>
    <p>Vive Escamillo ! Vive Escamillo !</p>
    <Translation mdxType="Translation">ばんざい、エスカミーリョ！</Translation>
    <p>Ah ! bravo !</p>
    <Translation mdxType="Translation">ああ！ ブラボー！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>Les voici ! voici la quadrille,</p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <p>La quadrille des Toreros !</p>
    <Translation mdxType="Translation">闘牛士のクアドリリャだ！</Translation>
    <p>Sur les lances, le soleil brille !</p>
    <Translation mdxType="Translation">槍の上に、太陽が輝く！</Translation>
    <p>En l'air, en l'air, en l'air, en l'air, toques et sombreros !</p>
    <Translation mdxType="Translation">宙に舞う、トック帽とソンブレロ！</Translation>
    <p>Les voici ! voici la quadrille,</p>
    <Translation mdxType="Translation">ほら、来たぞ！ クアドリリャがやって来た！</Translation>
    <p>La quadrille des Toreros !</p>
    <Translation mdxType="Translation">闘牛士のクアドリリャだ！</Translation>
    <p>Vive Escamillo ! Ah ! Vive Escamillo ! Vive Escamillo !</p>
    <Translation mdxType="Translation">
  ばんざい、エスカミーリョ！ ああ！ ばんざい、エスカミーリョ！
    </Translation>
    <p>Bravo ! Viva ! bravo ! bravo !</p>
    <Translation mdxType="Translation">ブラボー！ ばんざい！ ブラボー！ ブラボー！</Translation>
    <h2 name="sheet">楽譜</h2>
    <Note mdxType="Note">長いので2つの画像に分割されています。</Note>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/963b36e6580b8944ea89036e4f0c0304/8698d/carmen-les-voici-1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "595.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜1",
            "title": "楽譜1",
            "src": "/static/963b36e6580b8944ea89036e4f0c0304/5a190/carmen-les-voici-1.png",
            "srcSet": ["/static/963b36e6580b8944ea89036e4f0c0304/772e8/carmen-les-voici-1.png 200w", "/static/963b36e6580b8944ea89036e4f0c0304/e17e5/carmen-les-voici-1.png 400w", "/static/963b36e6580b8944ea89036e4f0c0304/5a190/carmen-les-voici-1.png 800w", "/static/963b36e6580b8944ea89036e4f0c0304/c1b63/carmen-les-voici-1.png 1200w", "/static/963b36e6580b8944ea89036e4f0c0304/8698d/carmen-les-voici-1.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/56c9e6844c08ed4caa443c1b76f83506/8698d/carmen-les-voici-2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "595.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜2",
            "title": "楽譜2",
            "src": "/static/56c9e6844c08ed4caa443c1b76f83506/5a190/carmen-les-voici-2.png",
            "srcSet": ["/static/56c9e6844c08ed4caa443c1b76f83506/772e8/carmen-les-voici-2.png 200w", "/static/56c9e6844c08ed4caa443c1b76f83506/e17e5/carmen-les-voici-2.png 400w", "/static/56c9e6844c08ed4caa443c1b76f83506/5a190/carmen-les-voici-2.png 800w", "/static/56c9e6844c08ed4caa443c1b76f83506/c1b63/carmen-les-voici-2.png 1200w", "/static/56c9e6844c08ed4caa443c1b76f83506/8698d/carmen-les-voici-2.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      